import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M185-186q-16 0-28-11t-11-29q0-16 11-28 12-11 28-11h36v-290q0-89 51-161 52-71 138-90v-19q0-29 21-49 20-21 49-21t49 21q21 20 21 49v19q86 18 138 90t52 161v290h35q16 0 28 11 12 12 12 29t-12 28q-12 11-28 11H185Zm295-314Zm0 439q-35 0-60-25t-25-60h170q0 35-25 60t-60 25ZM300-265h360v-290q0-74-52-127-53-53-128-53t-127 53q-53 53-53 127v290Z"/>',
  f: '<path d="M185-186q-16 0-28-11-11-12-11-28 0-17 11-29 12-11 28-11h36v-290q0-89 51-161 52-71 138-90v-19q0-29 21-49 20-21 49-21t49 21q21 20 21 49v19q86 18 138 90t52 161v290h35q16 0 28 11 12 12 12 29 0 16-12 28-12 11-28 11H185ZM480-61q-35 0-60-25t-25-60h170q0 35-25 60t-60 25Z"/>',
};

export default data;
